export default class TaxEventCommentPayload {
    comment = '';
}
